document.addEventListener('DOMContentLoaded', function () {
    
    if (cartToast != null && cartToast != undefined && typeof NUMCARTMENU !== 'undefined') {
        if (NUMCARTMENU > 0) {
            cartToast.show();
        }
    }
});
var btngo = document.querySelectorAll(".go");
if (btngo != null) {
    if (btngo.length > 0) {
        btngo.forEach(function (btn) {
            btn.addEventListener("click", function () {
                showloader();
            });
        });
    }
}
var inputElementsclear = document.querySelectorAll(".cleartext");
if (inputElementsclear != null) {
    if (inputElementsclear.length > 0) {
        inputElementsclear.forEach(function (input) {
            input.addEventListener("input", function () {
                var valor = input.value;
                var valorFiltrado = valor.replace(/[^A-Za-zñÑáéíóúÁÉÍÓÚ\s]/g, "");
                input.value = valorFiltrado;
            });
        });
    }
}

var inputElementsclear2 = document.querySelectorAll(".cleartextnum");
if (inputElementsclear2 != null) {
    if (inputElementsclear2.length > 0) {
        inputElementsclear2.forEach(function (input) {
            input.addEventListener("input", function () {
                var valor = input.value;
                var valorFiltrado = valor.replace(/[^0-9]/g, "");
                input.value = valorFiltrado;
            });
        });
    }
}
var inputElementsclear3 = document.querySelectorAll(".clearnif");
if (inputElementsclear3 != null) {
    if (inputElementsclear3.length > 0) {
        inputElementsclear3.forEach(function (input) {
            input.addEventListener("input", function () {
                var valor = input.value;
                var valorFiltrado = valor.replace(/[^0-9A-Za-zñÑ]/g, "");
                input.value = valorFiltrado;
            });
        });
    }
}

(() => {
    "use strict";

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
        form.addEventListener(
            "submit",
            (event) => {
                if (!form.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                    hideLoader();
                }
                if (tieneCampoPassword(form)) {
                    if (form.password == null) {
                        event.preventDefault();
                        event.stopPropagation();
                        hideLoader();
                    } else {
                        if (!form.password.classList.contains("notvalid")) {
                            if (form.password.value == null || form.password.value == "") {
                                event.preventDefault();
                                event.stopPropagation();
                                hideLoader();
                            } else if (!validarPassword(form.password.value)) {
                                event.preventDefault();
                                event.stopPropagation();
                                hideLoader();
                            }
                        }
                    }
                }

                form.classList.add("was-validated");
            },
            false
        );
    });
})();
function tieneCampoPassword(formulario) {
    // Obtén todos los elementos de entrada del formulario.
    var elementos = formulario.elements;

    // Itera a través de los elementos y verifica si alguno de ellos es un campo de contraseña.
    for (var i = 0; i < elementos.length; i++) {
        if (elementos[i].type === "password") {
            return true; // Se encontró al menos un campo de contraseña.
        }
    }

    return false; // No se encontró ningún campo de contraseña.
}

const validarPasswordsIguales = (input1, input2) => {
    if (input1.value !== input2.value) {
        input1.classList.add("is-invalid");
        input2.classList.add("is-invalid");
        return false;
    }
    if (!validarPassword(input1.value, false)) {
        input1.classList.add("is-invalid");
        input2.classList.add("is-invalid");
        return false;
    }
    input1.classList.remove("is-invalid");
    input2.classList.remove("is-invalid");

    return true;
}
const validarPassword = (password, popup = true, login = false) => {


    if (password.length > 5) {
        return true; // La contraseña cumple con el requisito.
    } else {
        if (popup && !login) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "La contraseña debe contener al menos 6 carácter",
            });
        } else if (popup && login) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Vefique los datos ingresados, porque no son validos el email o la contraseña.",
            });
        }

        return false; // La contraseña no cumple con el requisito.
    }
}

const toggler = document.querySelector("#menup");
if (toggler != null) {
    toggler.addEventListener("click", function () {
        let divwrapper = document.querySelector("#sidebar-wrapper");
        divwrapper.classList.toggle("collapsed")
        let icono = this.querySelector("i");
        icono.classList.toggle("bi-list");
        icono.classList.toggle("bi-x-lg");
    });
}


const SearchinTabla = (input, table) => {

    let filter = input.value.toLowerCase();
    let tr = table.getElementsByTagName('tr');
    for (let i = 1; i < tr.length; i++) {
        let row = tr[i];
        let cells = row.getElementsByTagName('td');
        let match = false;
        for (let j = 0; j < cells.length; j++) {
            let cell = cells[j];

            if (cell) {
                let text = cell.innerText || cell.textContent;
                text = text.toLowerCase();
                if (text.indexOf(filter) > -1) {
                    match = true;
                    break; // Si hay coincidencia, no es necesario verificar las otras celdas
                }
            }
        }
        // Mostrar u ocultar la fila según si hay coincidencia
        if (match) {
            row.style.display = '';
        } else {
            row.style.display = 'none';
        }
    }
}
const reloaddt = (table) => {
    $('#' + table).DataTable().ajax.reload();

}

const ValidateChecks1min = (event,nameclass) => {
    let div = document.querySelector(nameclass);
    let checks = div.querySelectorAll("input[type='checkbox']");
    if (checks != null) {
        if (checks.length > 0) {
            let checked = false;
            checks.forEach(function (check) {
                if (check.checked) {
                    checked = true;
                }
            });
            if (checked) {
                showloader();
            } else {
                event.preventDefault();
                event.stopPropagation();
            }
        } else {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}

function validateDates(fechaini, fechafin) {
    if(fechaini.value == "" || fechafin.value == ""){
        return;
    }
    const dateStart = new Date(fechaini.value);
    const dateEnd = new Date(fechafin.value);
    if (dateEnd < dateStart ) {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'La fecha final debe ser al menos un día después de la fecha inicial.',
        });
    }
}
const changeTextchek=(check,Nocheck, Yescheck) => {
    if (check.checked) {
        check.nextElementSibling.innerHTML = Yescheck;
    } else {
        check.nextElementSibling.innerHTML = Nocheck;
    }
}

